import React, { useState, useEffect } from 'react';
import { Layout, Space, Divider, Avatar, Dropdown, Typography } from 'antd';
import { UserOutlined, LogoutOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import NotificationBell from './NotificationBell';
import { authService } from '../services/api';

const { Header } = Layout;
const { Text } = Typography;

const AppHeader = () => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const data = await authService.getCurrentUser();
        setUser(data);
      } catch (err) {
        // Not logged in or token expired
      }
    };
    fetchUser();
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    navigate('/login');
  };

  const firstName = user?.full_name?.split(' ')[0] || '';
  const initials = user?.full_name
    ? user.full_name.split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
    : '';

  const menuItems = [
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: handleLogout,
    },
  ];

  return (
    <Header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 24px' }}>
      <div className="logo" style={{ color: 'white', fontSize: '18px', fontWeight: 'bold' }}>
        Vendor Cost AI
      </div>
      <Space size="middle" align="center">
        <NotificationBell />
        <Divider type="vertical" style={{ background: 'rgba(255,255,255,0.3)', height: 20 }} />
        <Dropdown menu={{ items: menuItems }} placement="bottomRight">
          <Space style={{ cursor: 'pointer' }}>
            <Avatar size="small" style={{ backgroundColor: '#1677ff' }}>
              {initials || <UserOutlined />}
            </Avatar>
            {firstName && (
              <Text style={{ color: 'white' }}>{firstName}</Text>
            )}
          </Space>
        </Dropdown>
      </Space>
    </Header>
  );
};

export default AppHeader;
